import { Pipe, PipeTransform } from '@angular/core';
import { AllProducts } from '@interfaces/SQL-morning-responses';

const calcModes = {
	netPrice: '1',
	cost: '2',
} as const;

type CalcModes = typeof calcModes[keyof typeof calcModes] extends string ? typeof calcModes[keyof typeof calcModes] : never;

@Pipe({
	name: 'profitCalc',
})
export class ProfitCalcPipe implements PipeTransform {
	transform(netPrice: number, CPP: number, calcMode: CalcModes): number | null {
		switch (calcMode) {
			case calcModes.netPrice:
				return ((netPrice - CPP) / netPrice) * 100;
			case calcModes.cost:
				return ((netPrice - CPP) / CPP) * 100;
			default:
				break;
		}
		return null;
	}
}
